import { useContent } from '../redux/reducer/content';
import { useCallback } from 'react';
import { getTypeBySlotType } from '../utils/helpers/helpers';

export const useClothType = () => {
  const { slots, notFilteredShopItems } = useContent();

  return useCallback(
    (arg) => {
      if (!slots || !notFilteredShopItems) return;

      const { slot } = notFilteredShopItems.find(({ id }) => id === arg);

      const clothType = slots.find((itemSlot) => itemSlot.system_name === slot).type;

      return getTypeBySlotType(clothType);
    },
    [slots, notFilteredShopItems],
  );
};
